import { ConnectAlternative } from '../../../screens/manage/connect/connect-alternative';
import { facebookConnectMessages as messages } from './facebook-connect-messages';

/** Facebook connect alternatives: standard OAuth (recommended) and Business OAuth. */
export const facebookConnectAlternatives: ConnectAlternative[] = [
  {
    id: 'standard',
    name: messages.standardName,
    description: messages.standardDescription,
    permissions: messages.standardPermissions,
    action: { type: 'oauth' },
    icon: 'login',
    recommended: true,
  },
  {
    id: 'business',
    name: messages.businessName,
    description: messages.businessDescription,
    permissions: messages.businessPermissions,
    action: { type: 'oauth', loginSuffix: 'business' },
    icon: 'business',
  },
];
